// extracted by mini-css-extract-plugin
export default {"input-custom":"formPolicy_input-custom__cJJi8","description":"formPolicy_description__QD+Lb"};